import { Component, Input, OnInit } from '@angular/core';
import { AtributosService } from '../../../servicios/atributos.service';
import { AppUtilService } from '../../../servicios/app.util.service';
import { HashKeyServices } from '../../../servicios/app.hashkey.services';
import { FormLoginComponent } from '../../../modal/form-login/form-login.component';
import { MatDialog } from '@angular/material/dialog';
import { nkServices } from '../../../servicios/app.nkservicios.services';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ToastNotificationService } from '../../../servicios/toast-notification.service';
import { environment } from 'src/environments/environment';
import { FormmMsgComponent } from '../../../modal/formm-msg/formm-msg.component';
import { AppComponent } from 'src/app/app.component';
import { FormRegistroAppComponent } from '../../../modal/form-registro-app/form-registro-app.component';
import { FormRecuperacionComponent } from '../../../modal/form-recuperacion/form-recuperacion.component';
import { FormPerfilComponent } from '../../../modal/form-perfil/form-perfil.component';
import { FormTestPreguntasComponent } from '../../../modal/form-test-preguntas/form-test-preguntas.component';
import { FormTestComponent } from '../../../modal/form-test/form-test.component';
import { TemasService } from '../../../servicios/temas.service';
import { AppRouterService } from '../../../servicios/app.router.service';

@Component({
  selector: 'app-header-pag',
  templateUrl: './header-pag.component.html',
  styleUrls: ['./header-pag.component.css']
})
export class HeaderPagComponent implements OnInit {
  @Input() cod_empresa: any;
  url:any = '../assets/img/fondo.png/'
  img:any;
  auth:any;
  nombre:any;
  promo:any = 'url("'+this.url+'")';
  logo:any;
  txt_h_1:any;
  constructor(
                private servicio:nkServices,
                private app:AppComponent,
                private dialog: MatDialog,
                private router:Router,
                private hashkey:HashKeyServices,
                private util:AppUtilService,
                private atrb:AtributosService,
                private notifi:ToastNotificationService,
                private tem:TemasService,
                private nav:AppRouterService,
  ){}

  ngOnInit() {
    this.img  = !localStorage.getItem('mgn')  ? this.atrb.IMAGENES_FIJAS.sin_img_log : this.hashkey.decrypt(localStorage.getItem('mgn')) === '' ? 
                  this.atrb.IMAGENES_FIJAS.sin_img_log : environment.path_storage+this.hashkey.decrypt(localStorage.getItem('mgn'));
    this.nombre  = !localStorage.getItem('nombre') ? '': this.hashkey.decrypt(localStorage.getItem('nombre'));
    this.auth  = !localStorage.getItem('cod_sesion') ? false: true;
    this.getParametrosApp();
  }

  async login(){
    try {
      let dialogRef = this.dialog.open(FormLoginComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {},
        disableClose: true,
        panelClass:'modal_login',
        backdropClass: "bdrop"
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.operacion.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
            if (result.operacion.toUpperCase() === await this.atrb.REGISTRO.toUpperCase()) {
                await this.util.cerrarSpinner();
              this.registroUsuario();
            }
            if (result.operacion.toUpperCase() === await this.atrb.LOGIN.toUpperCase()) {
              await this.util.cerrarSpinner();
              this.consultarusuario(result);
            }
            if (result.operacion.toUpperCase() === await this.atrb.RECUPERACION.recuperar_pass.toUpperCase()) {
              await this.util.cerrarSpinner();
              this.recuperarPass();
            }
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  async recuperarPass(){
    try {
      var dialogRef = this.dialog.open(FormRecuperacionComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {},
        disableClose: true,
        panelClass:'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.proceso.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
          await this.util.cerrarSpinner();
          await this.login();
        }else{
          await this.util.cerrarSpinner();
          await this.login();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  async perfilUsuario(){
    try {
        await this.util.abrirSpinner();
        let xobjeto = {
          cod_usuario:this.hashkey.decrypt(this.atrb.COD_USUARIO.cod_usuario),
          val_objeto:localStorage.getItem('vtr'),
          val_perfil:localStorage.getItem('prfrncs'),
          nombre: this.hashkey.decrypt(this.atrb.NOMBRE_USUARIO.nombre),
          nom_usuario: this.hashkey.decrypt(this.atrb.NOMBRE_USUARIO_APP.nom_usuario),
          correo: this.hashkey.decrypt(this.atrb.CORREO_USUARIO.correo),
          pass_usuario: this.hashkey.decrypt(this.atrb.PASS_USUARIO.pass_usuario),
        }
        await this.servicio.consultar_sesionhttp(null).toPromise();
        await this.util.cerrarSpinner();
      let  dialogRef = this.dialog.open(FormPerfilComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {
          data:xobjeto
        },
        disableClose: true,
        panelClass:'modal_reg',
        backdropClass: "bdrop"
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
          await this.util.cerrarSpinner();
          /* await this.gestionUsuarios(result); */
        }else{
          await this.util.cerrarSpinner();
         }
       });
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
    }
  }
  async consultarusuario(usuario:any){
    try {
      await this.util.abrirSpinner();
       usuario.api = await this.hashkey.encrypt(await this.atrb.API_REST.login);
       const response = await  this.servicio.ApiResthttp(usuario).toPromise();
          await  this.util.agregarLocalStorage(response);
          window.location.reload();
         await this.util.cerrarSpinner();
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
    }
  }
  async registroUsuario(){
    try {
      let  dialogRef = this.dialog.open(FormRegistroAppComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {},
        disableClose: true,
        panelClass:'modal_reg',
        backdropClass: "bdrop"
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.operacion.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
          await this.util.cerrarSpinner();
          await this.gestionUsuarios(result);
        }else{
          await this.util.cerrarSpinner();
         }
       });
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
    }
  }
  async gestionUsuarios(xvalor:any){
    try {
              if (xvalor.formdata.get('user_img') !== await this.atrb.UNDEFINED) {
                const img = await this.servicio.gestionarImgUserhttp(xvalor.formdata).toPromise();
                    xvalor.cod_img = img.file.path;
                    xvalor.des_img = img.file.filename;
            }else{
                    xvalor.cod_img = false;
                    xvalor.des_img = false;
            }
            xvalor.api = await this.hashkey.encrypt(await this.atrb.API_REST.ingresoUsuario);
        const response = await this.servicio.ApiResthttp(xvalor).toPromise();
        await this.util.cerrarSpinner();
                await this.notifi.success(response.message);
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
   }
 async cerrarsesion(){
    let accion = 'salir';
    var dialogRef = this.dialog.open(FormmMsgComponent, {
      width: '100vw',
          maxWidth: '100vw',
          height:'auto',
      data: {id:'',
            accion:accion},
      disableClose: true,
      panelClass: 'pedidos_modal',
      backdropClass: "bdrop"
    });
    dialogRef.afterClosed().subscribe(async result => {
      await this.util.abrirSpinner();
      if (result != 'salir') {
        await this.util.cerrarSpinner();
      }else{
        await this.util.cerrarSpinner();
        await this.app.cerrarsesion();
      }
    });
  }
 async getParametrosApp(){
    try {
      /* await  this.srvc.consultar_sesionhttp(null).toPromise(); */
      let valor = {
        termino: await this.atrb.DEF.toUpperCase(),
        cod_app : await this.hashkey.encrypt(environment.path_token),
        cod_empresa : await localStorage.getItem('cod_empresa') ? await localStorage.getItem('cod_empresa'): this.cod_empresa,
        api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicaciones)
      }
      const response = await this.servicio.ApiResthttp(valor).toPromise();
      let img_val;
      for (const i in response) {
        img_val = response[i].constante_app.split('_');
        if (img_val[0].toUpperCase() === await this.atrb.IMG.toUpperCase()) {
          response[i].img = environment.path_storage+response[i].val_def;
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_LOGO.toUpperCase()) {
            this.logo = response[i].img;
          }
        }
        if (img_val[0].toUpperCase() === await this.atrb.TXT.toUpperCase()) {
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_H_1.toUpperCase()) {
            this.txt_h_1 = response[i].val_def;
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  async inicioApp(){
    try {
      await this.util.abrirSpinner();
        await this.servicio.consultar_sesionhttp(null).toPromise();
      await this.util.cerrarSpinner();
      await this.nav.rutas_app(await this.atrb.PARAMETROS_RUTAS.INICIO);
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async homeApp(){
    try {
      await this.util.abrirSpinner();
        await this.servicio.consultar_sesionhttp(null).toPromise();
      await this.util.cerrarSpinner();
      await this.nav.rutas_app(await this.atrb.PARAMETROS_RUTAS.HOME);
    } catch (error) {
      console.log(error);
        await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
}
